<template>
  <div :class="{ 'visas': true, 'is-loading': !loaded }">
    <fieldset>
      <legend>Visas</legend>

      <d-alert
        v-if="referenceId === 0"
        theme="light"
        show
        class="text-center">
        You will be able to see and add visas after saving this {{ itemName }}.
      </d-alert>

      <d-alert
        v-if="loadError"
        theme="warning"
        show
        class="text-center">
        An error occurred during loading visas.
      </d-alert>

      <d-row
        v-if="loaded && !loadError && referenceId !== 0"
        class="pr-3 mb-3">
        <d-button
          theme="success"
          @click.prevent="addDocument"
          outline
          class="ml-auto">
          Add visa
        </d-button>
      </d-row>

      <d-row
        v-if="loaded && !loadError && referenceId !== 0"
        class="pl-3 pr-3">
        <table class="table">
          <thead>
            <tr>
              <th>Name</th>
              <th>Country</th>
              <th>Valid for</th>
              <th>End date</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            <visas-list-item
              v-for="(visaData, index) of visas"
              :key="'visas-list-item-' + index"
              :visaData="visaData" />
          </tbody>
        </table>
      </d-row>

      <d-alert
        v-if="loaded && !loadError && referenceId !== 0 && visas.length === 0"
        theme="light"
        show
        class="text-center">
        There are no visas for this {{ itemName }}.
      </d-alert>
    </fieldset>
  </div>
</template>

<script>
import FormUtils from './../../utils/FormUtils.js';
import VisasListItem from './VisasListItem.vue';

export default {
  name: 'visas',
  components: {
    'visas-list-item': VisasListItem
  },
  props: {
    referenceType: {
      type: String,
      required: true
    },
    referenceId: {
      type: Number,
      required: true
    },
    itemName: {
      type: String,
      required: true
    }
  },
  data () {
    return {
      loaded: false,
      loadError: false,
      visas: []
    };
  },
  mounted () {
    if (this.referenceId === 0) {
      this.loaded = true;
    } else {
      this.loadVisas();
    }

    this.$bus.$on('visas-list-reload', this.reload);
  },
  methods: {
    loadVisas () {
      FormUtils.loadAdditionalData(this, {
        endpoint: '/visas/items',
        params: {
          pagination: 0,
          where: {
            reference_id: this.referenceId,
            reference_type: this.referenceType
          }
        },
        loadedKey: 'loaded',
        outputKey: 'visas',
        errorKey: 'loadError'
      });
    },
    addDocument () {
      this.$bus.$emit('show-visa-popup', 'add', this.referenceType, this.referenceId);
    },
    reload () {
      this.loaded = false;
      this.loadVisas();
    }
  },
  beforeDestroy () {
    this.$bus.$off('visas-list-reload', this.reload);
  }
}
</script>

<style lang="scss" scoped>
.visas {
  margin: 30px 0;
  position: relative;

  &.is-loading {
    fieldset {
      min-height: 120px;
    }

    &:after {
      background: rgba(255, 255, 255, .66);
      content: "";
      height: 100%;
      left: 0;
      position: absolute;
      top: 0;
      width: 100%;
    }

    &:before {
      content: "Loading data...";
      left: 50%;
      position: absolute;
      top: 50%;
      transform: translateX(-50%) translateY(-50%);
      z-index: 1;
    }
  }
}
</style>
